import { useEffect, useState } from "react";
import { Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import moment from "moment";
import { useTheme } from "../../themes/ThemeContext";

const HcIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" height="18" width="18">
    <path
      d="M16 0H13L3.70711 9.29289L2.20711 7.79289L0.792893 9.20711L3.08579 11.5L1.5835 13.0023C1.55586 13.0008 1.52802 13 1.5 13C0.671573 13 0 13.6716 0 14.5C0 15.3284 0.671573 16 1.5 16C2.32843 16 3 15.3284 3 14.5C3 14.472 2.99923 14.4441 2.99771 14.4165L4.5 12.9142L6.79289 15.2071L8.20711 13.7929L6.70711 12.2929L16 3V0Z"
      fill="#FF4C4C"
    />
  </svg>
);

const OpkIcon = () => (
  <svg fill="#4C9BFF" height="18" width="18" viewBox="0 0 510.31 510.31" xmlns="http://www.w3.org/2000/svg">
    <path d="M504.06,443.728c-8.341-8.341-21.845-8.341-30.165,0h-0.021L412.946,382.8c20.096-23.915,34.731-50.389,36.928-72.768 c1.131-11.733-7.424-22.165-19.157-23.317c-11.925-1.195-22.165,7.445-23.317,19.157c-0.256,2.773-1.067,5.803-2.091,8.917 l-59.648-59.627l128.235-128.235c2.325-2.347,4.096-5.205,5.141-8.341l30.165-90.496c2.56-7.68,0.555-16.128-5.141-21.845 c-5.717-5.717-14.187-7.701-21.845-5.141L391.719,31.27c-3.136,1.045-5.995,2.816-8.341,5.163L255.143,164.646L126.93,36.432 c-2.325-2.347-5.184-4.117-8.341-5.163L28.092,1.104c-7.616-2.56-16.128-0.597-21.824,5.141 c-5.717,5.717-7.723,14.165-5.163,21.845l30.165,90.496c1.045,3.136,2.816,5.995,5.163,8.341l128.213,128.213l-59.904,59.925 c-0.917-2.965-1.621-5.824-1.771-8.405c-0.704-11.755-10.88-20.693-22.592-20.011c-11.776,0.725-20.693,10.837-19.989,22.592 c1.344,22.251,16.149,49.237,36.864,73.643l-60.821,60.843c-8.341-8.341-21.845-8.341-30.165,0c-8.341,8.32-8.341,21.824,0,30.165 l30.165,30.165c4.16,4.16,9.621,6.251,15.083,6.251s10.901-2.091,15.083-6.251c8.32-8.341,8.32-21.845,0-30.165l60.907-60.928 c23.915,20.096,50.411,34.709,72.789,36.885c0.725,0.085,1.408,0.107,2.091,0.107c10.859,0,20.139-8.235,21.205-19.264 c1.152-11.712-7.445-22.165-19.157-23.296c-2.773-0.277-5.803-1.067-8.917-2.112l59.648-59.627l59.904,59.904 c-2.965,0.917-5.824,1.621-8.405,1.771c-11.776,0.704-20.715,10.816-20.011,22.592c0.683,11.307,10.091,20.032,21.269,20.032 c0.448,0,0.875,0,1.323-0.043c22.251-1.344,49.216-16.149,73.621-36.864l60.843,60.843c-8.32,8.32-8.32,21.824,0,30.165 c4.181,4.16,9.643,6.251,15.104,6.251c5.44,0,10.901-2.091,15.083-6.251l30.165-30.165 C512.38,465.552,512.38,452.048,504.06,443.728z M157.927,382.544c-5.653-4.587-11.2-9.557-16.448-14.784 c-0.149-0.149-0.299-0.32-0.448-0.469c-4.715-4.736-9.237-9.728-13.419-14.784l67.2-67.179l30.187,30.165L157.927,382.544z M298.194,207.696l-12.864-12.885L409.98,70.16l45.269-15.083l-15.104,45.248L315.495,224.998L298.194,207.696z" />
  </svg>
);

const getActionText = (mode, type) => {
  if (type === "opk") {
    return mode === "on" ? "entered OPK mode" : "left the victim pool";
  }
  return "went hardcore";
};

const ActivityItem = ({ entry, theme }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-between py-2"
      style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.08)" }}
    >
      <div className="d-flex align-items-center gap-2 text-truncate">
        <span className="d-flex flex-shrink-0">
          {entry.type === "hc" ? <HcIcon /> : <OpkIcon />}
        </span>
        <div className="text-truncate">
          <div className="d-flex align-items-center text-truncate">
            <NavLink
              to={`/player?player=${entry.name}`}
              className="text-truncate"
              style={{ color: theme.colors.surface["surface-light4"] }}
            >
              {entry.name}
            </NavLink>
          </div>
          <div
            className="text-truncate small"
            style={{ opacity: 0.6, color: theme.colors.surface["surface-light4"] }}
          >
            {getActionText(entry.mode, entry.type)}
          </div>
        </div>
      </div>
      <OverlayTrigger placement="top" overlay={<Tooltip>{entry.dateString}</Tooltip>}>
        <span
          className="small flex-shrink-0 ms-2"
          style={{ opacity: 0.55, color: theme.colors.surface["surface-light4"] }}
        >
          {moment(entry.createdAt).fromNow()}
        </span>
      </OverlayTrigger>
    </div>
  );
};

const ActivityColumn = ({ title, icon, data, loading, theme, spinnerVariant }) => (
  <Col md={6}>
    <div className="d-flex align-items-center gap-2 mb-2">
      {icon}
      <span
        className="text-uppercase small fw-bold"
        style={{ letterSpacing: "0.05em", color: theme.colors.surface["surface-light4"], opacity: 0.75 }}
      >
        {title}
      </span>
    </div>
    {(loading && (
      <div className="d-flex justify-content-center py-4">
        <div className={`spinner-border text-${spinnerVariant}`} role="status">
          <span className="sr-only" />
        </div>
      </div>
    )) ||
      (data.length === 0 && (
        <div
          className="small p-2"
          style={{ opacity: 0.5, color: theme.colors.surface["surface-light4"] }}
        >
          No recent activity.
        </div>
      )) ||
      data.map((entry) => <ActivityItem key={entry.id} entry={entry} theme={theme} />)}
  </Col>
);

export const RecentActivity = () => {
  const { theme } = useTheme();

  const [opkData, setOpkData] = useState([]);
  const [hcData, setHcData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_HOST = process.env.REACT_APP_API;

    const dataFetch = async () => {
      const data = await (
        await fetch(`${API_HOST}public/stats/recent-opkhc`)
      ).json();

      setHcData(data.filter((e) => e.type === "hc"));
      setOpkData(data.filter((e) => e.type === "opk"));

      setLoading(false);
    };

    dataFetch();

    const timeToFetch = 10 * 60 * 1000;
    const interval = setInterval(() => {
      dataFetch();
    }, timeToFetch);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <ActivityColumn
        title="Hardcore"
        icon={<HcIcon />}
        data={hcData}
        loading={loading}
        theme={theme}
        spinnerVariant="danger"
      />
      <ActivityColumn
        title="Open PK"
        icon={<OpkIcon />}
        data={opkData}
        loading={loading}
        theme={theme}
        spinnerVariant="primary"
      />
    </>
  );
};
